import { createReducer, INITIAL_STATE } from '@shared/redux';

import {
    API_INTEGRATE_URL,
    API_GET_DATA_URL,
} from './vtex.constants';

export const VTEX_SAVE_INTEGRATION_REQUEST_CALLED = '@integrations/vtex/SAVE_INTEGRATION_REQUEST_CALLED';
export const VTEX_SAVE_INTEGRATION_REQUEST_START = '@integrations/vtex/SAVE_INTEGRATION_REQUEST_START';
export const VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS = '@integrations/vtex/SAVE_INTEGRATION_REQUEST_SUCCESS';
export const VTEX_SAVE_INTEGRATION_REQUEST_ERROR = '@integrations/vtex/SAVE_INTEGRATION_REQUEST_ERROR';

export const VTEX_GET_DATA_REQUEST_CALLED = '@integrations/vtex/GET_DATA_REQUEST_CALLED';
export const VTEX_GET_DATA_REQUEST_START = '@integrations/vtex/GET_DATA_REQUEST_START';
export const VTEX_GET_DATA_REQUEST_SUCCESS = '@integrations/vtex/GET_DATA_REQUEST_SUCCESS';
export const VTEX_GET_DATA_REQUEST_ERROR = '@integrations/vtex/GET_DATA_REQUEST_ERROR';

export const getVtexState = state => ({
    ...state.integrations.vtex,
});

export type VtexIntegrationData = {
    accountName: string
    appKey: string
    appToken: string
    clientId: string
}

export const saveVtexIntegration = ({
    accountName,
    appKey,
    appToken,
    clientId,
}: VtexIntegrationData) => ({
    type: VTEX_SAVE_INTEGRATION_REQUEST_CALLED,
    actionTypes: {
        start: VTEX_SAVE_INTEGRATION_REQUEST_START,
        fail: VTEX_SAVE_INTEGRATION_REQUEST_ERROR,
        success: VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS,
    },
    config: {
        url: API_INTEGRATE_URL,
        method: 'POST',
        data: {
            account_name: accountName,
            app_key: appKey,
            app_token: appToken,
            client_id: clientId,
        },
    },
});

export const getVtexData = ({ clientId }) => ({
    type: VTEX_GET_DATA_REQUEST_CALLED,
    actionTypes: {
        start: VTEX_GET_DATA_REQUEST_START,
        fail: VTEX_GET_DATA_REQUEST_ERROR,
        success: VTEX_GET_DATA_REQUEST_SUCCESS,
    },
    config: {
        url: API_GET_DATA_URL,
        method: 'GET',
        params: {
            client_id: clientId,
        },
    },
});

export type State = {
  loading: boolean
  submitting: boolean
  integrationData: VtexIntegrationData
};

const initialState: State = {
    loading: true,
    submitting: false,
    integrationData: {
        accountName: '',
        appKey: '',
        appToken: '',
    },
};

export const vtexReducer = createReducer({
    [INITIAL_STATE]: initialState,
    [VTEX_SAVE_INTEGRATION_REQUEST_START]: (state: State): State => ({
        ...state,
        submitting: true,
    }),
    [VTEX_SAVE_INTEGRATION_REQUEST_SUCCESS]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [VTEX_SAVE_INTEGRATION_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        submitting: false,
    }),
    [VTEX_GET_DATA_REQUEST_START]: (state: State): State => ({
        ...state,
        loading: true,
    }),
    [VTEX_GET_DATA_REQUEST_SUCCESS]: (state: State, { payload: { data } }): State => ({
        ...state,
        loading: false,
        integrationData: {
            accountName: data.account_name,
            appKey: data.app_key,
            appToken: data.app_token,
        },
    }),
    [VTEX_GET_DATA_REQUEST_ERROR]: (state: State): State => ({
        ...state,
        loading: false,
    }),
});
